<template>
<!-- 三叶草勋章页面 -->
  <div class="ceping80_clover">
      <div class="header">
          <h5>三叶草勋章</h5>
          <div class="small">能力 兴趣 价值观</div>
      </div>
      <!--  -->
      <div class="content">
        
        <h3>古典老师亲授：用生涯三叶草做职业定位</h3>
        <div class="audio-box">
            <img v-if="!playAudio" class="paly" @click="playStart()" src="https://themes-cdn.xjy.cn/statics/career/images/ceping80/play.png"  alt="">
            <img v-else class="paly" @click="playStop()" src="https://themes-cdn.xjy.cn/statics/career/images/ceping80/off.png"  alt="">
            <div class="play-bar">
                <div class="bar-bg">
                    <div :style="{width:pgNum+'%'}" class="bar"></div>
                    <div :style="{left:(pgNum-0.5)+'%'}" class="bar-btn"></div>
                </div>
                <div class="time">
                    <span class="left">{{curTime}}</span>
                    <span class="right">10:00</span>
                </div>
            </div>
            <audio
                @timeupdate="playIng($event)"
                ref="audio"
                src="https://misc.xjy.cn/ceping/ceping80.mp3"
                controls="controls"
                oncontextmenu="return false"
                class="origin-player"
                preload="auto" v-show="false">
                你的浏览器不支持播放此音频
            </audio>
        </div>
        <div class="bg">
            <p class="title">什么是一个好的职业定位呢？</p>
            <p>那么，什么是一个好的职业定位呢？<br/>好的定位是向内找方向，向外找选项的选择，是一个你爱干、能干、值得干的事。<br/>接下来，我们通过一个“职业三叶草”模型来告诉你如何清晰自己的定位，调整自己的定位。<br/><br/>我们首先从评估你的职业现状开始，<br/>接下来，我会问你三个问题，每个问题都代表一个职业定位的关键要素。你可以通过打分，看清你的职业现状，每个要素满分都是5分。回答了这三个问题，你也许会发现，怎么也想不清楚的职业定位问题，在那你脑子里，逐渐清晰了。<br/>好，问题来了。</p>
            <p class="title">第一个问题是：你喜欢现在的工作内容，并愿意持续投入精力吗？</p>
            <p>一份爱干的工作才会让你投入更多热情和精力，对自己提出更高的要求。<br/>爱干爱干。什么叫真爱干？<br/><br/>有位同学非常爱打游戏，立志进入游戏行业，想要天天和游戏泡在一起。<br/>后来他在自我探索课的小组里遇到一位真正的游戏行业从业者，这个哥们一直抱怨游戏设计师的工作有大量重复的基础工作，十分枯燥乏味，很难获得成就感。两人深入交流之后，他才发现自己只是喜欢玩游戏，而不是喜欢游戏设计这份工作。<br/><br/>其实，很多人在没有体验一份工作之前，都会有一些直观的喜好，这并不是爱干。<br/>真正的爱干，是当你接触到体验到一个职业好的，同时也知道不好的一面以后，依然觉得有趣。如果非要标准的话，一个标准就是在工作之余，你还有兴趣读这个领域的专业书籍。<br/><br/>你可以思考一下，你现在的工作在“爱干”这个维度能打几分？</p>
            <p class="title">第二个问题是：这份工作能让你发挥优势，越干越好吗？</p>
            <p>大家都知道，从优势出发的工作，会带给你更高的收益和竞争力，就连心理学也发现，发挥优势是幸福的重要来源。说白了，发挥自己的优势的工作收入多，成长快，成就感和幸福感十足。<br/><br/>优势也有层级，初级优势是“自己更擅长于”什么，比如说“相比演讲，我更擅长笔头写作”，高阶优势是竞争优势，“比同行更优秀”，比如说“比其他的写作同行来说，我更擅长个人成长方面的认知类文章”。<br/><br/>思考一下——你现在的工作有多大程度发挥了自己的优势？你选择的领域，有多大机会把这个优势形成竞争力？有人可能会问，我觉得自己没有什么明显优势怎么办？<br/><br/>其实每个人都有潜在的优势，只是你没有发现而已。今天我们先讲到这里，后面的课程会有专门的内容帮你挖掘优势。<br/><br/>你现在可以先给自己“能在当下工作发挥优势吗？”这个部分，给一个评估。</p>
            <p class="title">第三个问题是：你的工作值得干吗？</p>
            <p>什么叫值得干？简单说就是，这份工作能不能给表现足够优秀的人想要的回报。<br/>对于大部分人来说，有上升趋势、市场空间更大、行业更规范的工作整体回报更高。当然，这个标准因人而异，也根据不同发展阶段不同。<br/><br/>我举个例子，我有两位作家朋友，同样有才华也同样努力，一位写小说，另一位写现代诗。在今天的社会里，很明显，前者工作就比后者投入产出比更高。<br/>如果用赚钱来衡量值不值得干，写小说肯定比写诗歌更值得干。如果用艺术追求来衡量，写诗歌可能就高一些，<br/><br/>好的，那么对于你来说，你的工作值得干吗？在这个领域，你会给自己打几分？<br/><br/>好，三个问题问完了，你可以把3个数字写下来，比如334，253。我们一会会告诉你怎么解读这个数字。我们现在先来看一个模型，叫做职业三叶草模型。<br/><br/>刚刚我问了三个问题，这三个问题背后的要素分别是“爱干”、“能干”和“值得干”。</p>
            <p class="title">如何定位一份工作是最适合我的？</p>
            <p>记个口诀——一份“爱干、能干、值得干的工作，是最适合你的好工作。<br/>因为这三个坐标的交叉点，就是你职业发展的甜蜜点定位。<br/><br/>爱干让你持续保持激情，持续学习；<br/>能干让你在竞争里保持优势；<br/>值得干则让你有足够多的回报，能支撑你做下一轮的投入。<br/><br/>现在也许你发现了，爱干、能干、值得干，这三要素之间还能产生动态联动：<br/>“爱干”的工作让你主动投入时间，变得越来越能干；<br/>“能干”给你提供竞争力和成就感，让工作回报越来越多；<br/>“值得干”的领域会给你足够多的回报，让你有余力投入探索更多爱干和能干的事。<br/>并不一定会马上找到，但是一定要持续的找，不断的自我探索，逐渐你的职业发展会走向一个正向的循环，形成你自己的增长飞轮。<br/><br/>所以，职业三叶草模型告诉你。<br/>如果你在选择方向或者转型，那么可以用爱干能干值得干，定位自己的新职业方向。<br/>如果你希望在当前工作里，突破职业瓶颈，那么找到当前工作里你最爱干能干值得干的部分，持续投入，会成为你的职业突破口。<br/>如果你是创业或者副业，那么选择一件爱干能干的，慢慢把这件事做成值得干的，就是创业法门。<br/><br/>
                <img src="https://themes-cdn.xjy.cn/statics/career/images/ceping80/clover-flow1.png" width="100%" alt=""><br/><br/><br/>
                今天我们讲了职业定位的三叶草模型。<br/>一个完美的职业定位，就是爱干、能干、又值得干。这三片叶子的交汇点，就是你应该去追求的职业发展甜蜜点。<br/>我们讲到了评估和调整这三个领域的方法：找到新的领域、提升能力结构以及探索内在动力，也谈到了系统的评估和简易评估的方法。
            </p>
            <p class="title">最后要叮嘱的是：</p>
            <p>从不完美到完美，很难一步到位。面对职业的不完美，你要做的第一步是冷静的通过自我探索，找到当前工作不够完美的叶片。慢慢去调整，最终让自己的三叶草旋转起来。</p>





            <!-- <p>什么是一个好的职业定位呢？<br/>好的定位是向内找方向，向外找选项的选择，是一个你爱干、能干、值得干的事。<br/>接下来，我们通过一个“职业三叶草”模型来告诉你如何清晰自己的定位，调整自己的定位。<br/></p>
            <p>我们首先从评估你的职业现状开始，<br/>接下来，我会问你三个问题，每个问题都代表一个职业定位的关键要素。你可以通过打分，看清你的职业现状，每个要素满分都是5分。回答了这三个问题，你也许会发现，怎么也想不清楚的职业定位问题，在那你脑子里，逐渐清晰了。<br/></p>
            <p>好，问题来了。</p>
            <p>第一个问题是：你喜欢现在的工作内容，并愿意持续投入精力吗？</p>
            <p>一份爱干的工作才会让你投入更多热情和精力，对自己提出更高的要求。</p>
            <p>爱干爱干。什么叫真爱干？</p>
            <p>有位同学非常爱打游戏，立志进入游戏行业，想要天天和游戏泡在一起。<br/>后来他在自我探索课的小组里遇到一位真正的游戏行业从业者，这个哥们一直抱怨游戏设计师的工作有大量重复的基础工作，十分枯燥乏味，很难获得成就感。两人深入交流之后，他才发现自己只是喜欢玩游戏，而不是喜欢游戏设计这份工作。</p>
            <p>其实，很多人在没有体验一份工作之前，都会有一些直观的喜好，这并不是爱干。<br/>真正的爱干，是当你接触到体验到一个职业好的，同时也知道不好的一面以后，依然觉得有趣。如果非要标准的话，一个标准就是在工作之余，你还有兴趣读这个领域的专业书籍。</p>
            <p>你可以思考一下，你现在的工作在“爱干”这个维度能打几分？</p>
            <p>第二个问题是：这份工作能让你发挥优势，越干越好吗？</p>
            <p>大家都知道，从优势出发的工作，会带给你更高的收益和竞争力，就连心理学也发现，发挥优势是幸福的重要来源。说白了，发挥自己的优势的工作收入多，成长快，成就感和幸福感十足。</p>
            <p>优势也有层级，初级优势是“自己更擅长于”什么，比如说“相比演讲，我更擅长笔头写作”，高阶优势是竞争优势，“比同行更优秀”，比如说“比其他的写作同行来说，我更擅长个人成长方面的认知类文章”。</p>
            <p>思考一下——你现在的工作有多大程度发挥了自己的优势？你选择的领域，有多大机会把这个优势形成竞争力？</p>
            <p>有人可能会问，我觉得自己没有什么明显优势怎么办？</p>
            <p>其实每个人都有潜在的优势，只是你没有发现而已。今天我们先讲到这里，后面的课程会有专门的内容帮你挖掘优势。</p>
            <p>你现在可以先给自己“能在当下工作发挥优势吗？”这个部分，给一个评估。</p>
            <p>第三个问题是：你的工作值得干吗？<br/>什么叫值得干？简单说就是，这份工作能不能给表现足够优秀的人想要的回报。<br/>对于大部分人来说，有上升趋势、市场空间更大、行业更规范的工作整体回报更高。当然，这个标准因人而异，也根据不同发展阶段不同。</p>
            <p>我举个例子，我有两位作家朋友，同样有才华也同样努力，一位写小说，另一位写现代诗。在今天的社会里，很明显，前者工作就比后者投入产出比更高。<br/>如果用赚钱来衡量值不值得干，写小说肯定比写诗歌更值得干。如果用艺术追求来衡量，写诗歌可能就高一些，好的，那么对于你来说，你的工作值得干吗？在这个领域，你会给自己打几分？</p>
            <p>好，三个问题问完了，你可以把3个数字写下来，比如334，253。我们一会会告诉你怎么解读这个数字。我们现在先来看一个模型，叫做职业三叶草模型</p>
            <p>刚刚我问了三个问题，这三个问题背后的要素分别是“爱干”、“能干”和“值得干”。</p>
            <p>如何定位一份工作是最适合我的？<br/>记个口诀——一份“爱干、能干、值得干的工作，是最适合你的好工作。<br/>因为这三个坐标的交叉点，就是你职业发展的甜蜜点定位。</p>
            <p class="on">爱干让你持续保持激情，持续学习；<br/>能干让你在竞争里保持优势；<br/>值得干则让你有足够多的回报，能支撑你做下一轮的投入。</p>
            <p>现在也许你发现了，爱干、能干、值得干，这三要素之间还能产生动态联动：<br/>“爱干”的工作让你主动投入时间，变得越来越能干；<br/>“能干”给你提供竞争力和成就感，让工作回报越来越多；<br/>“值得干”的领域会给你足够多的回报，让你有余力投入探索更多爱干和能干的事。<br/>并不一定会马上找到，但是一定要持续的找，不断的自我探索，逐渐你的职业发展会走向一个正向的循环，形成你自己的增长飞轮。</p>
            <p>所以，职业三叶草模型告诉你。<br/>如果你在选择方向或者转型，那么可以用爱干能干值得干，定位自己的新职业方向。<br/>如果你希望在当前工作里，突破职业瓶颈，那么找到当前工作里你最爱干能干值得干的部分，持续投入，会成为你的职业突破口。<br/>如果你是创业或者副业，那么选择一件爱干能干的，慢慢把这件事做成值得干的，就是创业法门。</p>
            <p>
                
            </p>
            <p>今天我们讲了职业定位的三叶草模型。<br/>一个完美的职业定位，就是爱干、能干、又值得干。这三片叶子的交汇点，就是你应该去追求的职业发展甜蜜点。<br/>我们讲到了评估和调整这三个领域的方法：找到新的领域、提升能力结构以及探索内在动力，也谈到了系统的评估和简易评估的方法。</p>
            <p>最后要叮嘱的是：<br/>从不完美到完美，很难一步到位。面对职业的不完美，你要做的第一步是冷静的通过自我探索，找到当前工作不够完美的叶片。慢慢去调整，最终让自己的三叶草旋转起来。</p> -->
        
        </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            curTime:'00:00',
            playAudio:false,
            audio:null,
            pgNum:0
        }
    },
    mounted(){
      // 元素
      this.audio = this.$refs.audio;
    },
    methods:{
         // 当前时间的格式化字符串
      timeTostring(s){
        var MM = Math.floor(s / 60);
        var SS = s % 60;
        if(MM < 10) MM = "0" + MM;
        if(SS < 10) SS = "0" + SS;
        var min = MM + ":" + SS;
        return min.split('.')[0];
      },
      // 手动调用
      playStart(){
        // 开始播放器
        this.audio.play();
        this.playAudio = true;
      },
      playStop(){
        // 暂停播放
        this.audio.pause();
        this.playAudio = false;
      },
      // 拖动滑块
      moveSlider(num){
        setTimeout(() => {
          this.lock = false;
          this.audio.currentTime = this.audio.duration * ( num / 100 );
          this.playStart();
        }, 0)
      },
      // 播放器事件
      playIng(ev){
        // 计算当前时间
        let curTime = ev.srcElement.currentTime;
        this.curTime = this.timeTostring(curTime);
        // 触发自定义事件 playing -- 播放中
        // this.$emit('playing', ev, this.curTime, this.allTime);
        // 是否vant slider正在拖拽， 监听属性变化值得大小判断
        // if( this.lock ){
        //   return
        // }
        // 计算当前时间与滑块的值
        let allTime = ev.srcElement.duration;
        this.pgNum = Math.floor( (curTime / allTime) * 100 );
      },
      stopPlay(ev){
        // this.start = false;

        // if(this.ready) {
        //   this.state = 0;
        // }
        // 触发自定义事件 playstop -- 播放暂停
        // this.$emit('playstop', ev);
      },
      startPlay(ev){
        this.start = true;

        if(this.ready){
          this.state = 2;
        }
        // 触发自定义事件 playstart -- 播放开始
        // this.$emit('playstart', ev);
      },
        /*
         *@param: 
         *@return: 
         *@Description: 初始化获取数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2020-11-24 16:05:25
        */
        pullData(){
            document.title = '海岛历险';
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
    .ceping80_clover{
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #F7F8F9;
        .header{
            background: url('../../../assets/ceping80/clover-bg.png') center no-repeat;
            background-size: cover;
            width: 690px;
            height: 280px;
            margin-top: 30px;
            padding: 80px 30px;
            h5{
                font-size: 60px;
                color: #FFFFFF;
                font-weight: bold;
                line-height: 1;
                margin-bottom: 30px;
            }
            .small{
                font-size: 28px;
                color: #FFFFFF;
            }
        }
        .content{
            background: #FFFFFF;
            box-shadow: 0px 2px 6px 3px rgba(0, 0, 0, 0.03);
            border-radius: 30px 30px 0px 0px;
            padding: 0px 30px 60px;
            h3{
                font-size: 32px;
                margin: 40px auto 30px;
                font-weight: bold;
            }
            .audio-box{
                background-color: #F7F8F9;
                width: 690px;
                height: 140px;
                border-radius: 20px;
                padding: 0px 30px;
                display: flex;
                align-items: center;
                margin-bottom: 40px;
                img.paly{
                    width: 62px;
                    height: 62px;
                    margin-right: 20px;
                }
                .play-bar{
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                    padding-top: 25px;
                    .bar-bg{
                        background-color: #FFFFFF;
                        border-radius: 8px;
                        height: 15px;
                        width: 100%;
                        margin-bottom: 10px;
                        position: relative;
                        .bar{
                            width: 12px;
                            height: 15px;
                            background: linear-gradient(-90deg, #FCEA39 0%, #F3AC00 100%);
                        }
                        .bar-btn{
                            width: 25px;
                            height: 25px;
                            background: #FCEA38;
                            border: 4px solid #FFFFFF;
                            overflow: hidden;
                            border-radius: 50%;
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            left: 0;
                        }
                    }
                    .time{
                        font-size: 22px;
                        color: #BABEC2;
                        display: flex;
                        .left{
                            margin-right: auto;
                        }
                    }
                }

            }
            .bg{
                background-color: #F7F8F9;
                padding: 28px 30px 40px;
                border-radius: 20px;
                p.title{
                    font-size: 30px;
                    color: #28333B;
                    margin-bottom: 27px;
                    font-weight: bold;
                }
                p{
                    font-size: 26px;
                    color: #7D8289;
                    margin-bottom: 60px;
                    line-height: 37px;
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
</style>